import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireStorage } from 'angularfire2/storage';

@Component({
  selector: 'app-privacy-statement',
  templateUrl: './privacy-statement.component.html',
  styleUrls: ['./privacy-statement.component.css']
})
export class PrivacyStatementComponent implements OnInit {

  private showSpinner: Boolean = true;
  private privacystatement: string;
  constructor(private http: HttpClient, private storage: AngularFireStorage) { }

  ngOnInit() {
    const x = this.storage.ref('/public/privacy.txt').getDownloadURL().subscribe(v => {
      if (v) {
        this.http.get(v, {responseType: 'text'}).subscribe(res => {
          if (res) {
            this.privacystatement = res;
            this.toggleSpinner();
          }
        });
      }
    });
  }

  toggleSpinner() {
    this.showSpinner = !this.showSpinner;
  }

  download() {
  }

}



// WEBPACK FOOTER //
// ./src/app/privacy-statement/privacy-statement.component.ts